import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Music from "./MusicLottie.json";

const Lottie = dynamic(() => import("react-lottie"), { ssr: false });

export default function AboutsContainer() {
  return (
    <>
      <section className="center_container lg:pt-24 aboutPg__bg">
        <div className="container" >
          <div className="row w-full p-2" style={{ margin: "auto" }}>
            <div className="about__text w-full lg:w-6/12 text-center px-2">
              <div className="wrap-line">
                <h1 style={{ color: "#FFF" }}>
                  <span className="font-light">About</span> us
                </h1>
              </div>
              <h3>
                CONNECTING FANS WITH MUSIC ARTISTS THROUGH SINGLE AND ALBUM ART
                AND MAKING MONEY IN THE PROCESS
              </h3>
              <p>
                A user-friendly online marketplace for single/album artwork,
                music posters, personalized messages, and autographs featuring
                low fees and transaction transparency, led by a team of experts
                passionate about art, and dedicated to introducing fans to a new
                way to discover music—giving new and welcome revenue streams to
                minters of all levels of popularity.
              </p>
              <p>
                Minted by a team of music industry experts resurrecting the
                once-common belief that an album’s artwork is nearly as
                important as the music it wraps, MusicArt lets musicians mint
                limited edition digital collectibles out of the album and single
                artwork, autographs, and posters. The NFTs can be one-offs or
                multiple limited editions of up to 1,000 or more. It’s all up to
                the musicartist.
              </p>
            </div>
            <div className="about__text w-full lg:w-6/12 text-center px-2">
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: Music,
                }}
                speed={1}
                style={{ margin: "auto", width: "100%" }}
              />
            </div>
          </div>
          <div
            className="row w-full p-2"
            style={{ margin: "auto", marginTop: 70 }}
          >
            <div className="about__text w-full lg:w-6/12 text-center px-2">
              <img
                src="/img/TheTech.png"
                alt=""
                style={{ width: "70%", paddingTop: "120px", margin: "auto" }}
              />
            </div>
            <div className="about__text w-full lg:w-6/12 text-center px-2">
              <div className="wrap-line">
                <h1 style={{ color: "#FFF" }}>
                  <span className="font-light">The</span> tech
                </h1>
              </div>
              <p>
                MusicArt runs on the Bitcoin BSV blockchain, which is 10,000x
                more energy efficient than the BTC blockchain.
              </p>
              <p>
                Bitcoin BSV is also one of the most scalable blockchains,
                allowing for a throughput of millions or more transactions per
                second.
              </p>
              <p>
                Normal transactions on BSV cost only a fraction of a cent.
                What’s more, MusicArt never charges transaction fees from the
                musicartists or the users
              </p>
              <p>
                Finally, the BSV protocol is stable. Digital art is stored 100%
                on-chain. Your NFTs are secure, and will not vanish if
                developers change the protocol. Our platform is built by Vaionex
                using TAAL's STAS token technology.
              </p>
              <h3>START COLLECTING MUSIC ART</h3>
            </div>
          </div>
          <div className="about_links w-full text-center py-10 lg:py-20">
            <p>
              <a
                href="https://www.facebook.com/musicart.nft"
                
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://twitter.com/MusicArt_nft"
                
                rel="noopener noreferrer"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://www.instagram.com/MusicArt.nft"
                target="_self"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
